import React from 'react'

export default function Facebook() {
    return (
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.51868 2.1588C5.18519 2.0908 4.73478 2.04 4.45151 2.04C3.68448 2.04 3.63465 2.38 3.63465 2.924V3.8924H5.55203L5.38489 5.8984H3.63465V12H1.23391V5.8984H0L0 3.8924H1.23391V2.6516C1.23391 0.951999 2.01742 0 3.98463 0C4.66809 0 5.16832 0.102 5.81843 0.238L5.51868 2.1588Z" fill="white" />
        </svg>
    )
}
